module.exports = {
    KEY_CODE_TAB: 9,
    KEY_CODE_ENTER: 13,
    KEY_CODE_ESC: 27,
    KEY_CODE_SPACE: 32,
    KEY_CODE_LEFT: 37,
    KEY_CODE_UP: 38,
    KEY_CODE_RIGHT: 39,
    KEY_CODE_DOWN: 40
};
